import React from 'react';
import SeoLandingPage from '../components/SeoLandingPage';

const PageInvestissementImmobilierAnnecy = () => (
  <SeoLandingPage
    slug="investissement-immobilier-locatif-annecy"
    title="Investissement immobilier locatif Annecy - Pinel, LMNP, SCPI"
    description="Investissement immobilier locatif à Annecy : Pinel, LMNP, Denormandie, SCPI. Conseiller indépendant en Haute-Savoie. Bilan offert, accompagnement sur-mesure."
    keywords="investissement immobilier locatif Annecy, investissement locatif Haute-Savoie, immobilier Annecy, Pinel Annecy, LMNP Annecy, SCPI Annecy, investissement Pinel Annecy-le-Vieux, investissement locatif Cluses, immobilier neuf Annecy"
    h1="Investissement immobilier locatif à Annecy : construire un patrimoine durable"
    subtitle="Annecy, l'une des villes les plus dynamiques de France, offre un marché locatif tendu et un fort potentiel de valorisation. En tant que conseiller indépendant, je vous aide à choisir le bon dispositif (Pinel, LMNP, SCPI) selon vos objectifs : revenus complémentaires, défiscalisation ou transmission."
    schemaService="Investissement immobilier locatif à Annecy et en Haute-Savoie"
    sections={[
      {
        title: "Pourquoi investir dans l'immobilier locatif à Annecy ?",
        body: "Annecy et son bassin (Annecy-le-Vieux, Cran-Gevrier, Seynod, Meythet, Veyrier-du-Lac, Saint-Jorioz, Faverges) figurent parmi les marchés les plus tendus de France. La proximité de la Suisse, l'attractivité touristique, la qualité de vie et la dynamique économique font de cette zone un terrain d'investissement particulièrement sécurisé.",
        bullets: [
          "Marché locatif sous tension permanente",
          "Demande forte des frontaliers et des étudiants",
          "Valorisation patrimoniale historiquement supérieure à la moyenne nationale",
          "Cadre fiscal stable et incitatif (Pinel, LMNP, Denormandie)",
          "Proximité Suisse : loyers attractifs"
        ]
      },
      {
        title: "Les dispositifs d'investissement locatif disponibles",
        body: "Plusieurs dispositifs permettent d'investir dans l'immobilier locatif avec une optimisation fiscale. Le choix dépend de votre tranche d'imposition, de votre horizon d'investissement et de votre tolérance au risque.",
        bullets: [
          "Pinel & Pinel+ : immobilier neuf, réduction d'impôt jusqu'à 14% sur 12 ans, idéal Annecy/Cran-Gevrier",
          "LMNP (Loueur Meublé Non Professionnel) : revenus locatifs faiblement fiscalisés, amortissement comptable",
          "Denormandie : achat-rénovation en centre-ville, jusqu'à 21% de réduction d'impôt",
          "Malraux : 22-30% de réduction d'impôt en secteur sauvegardé",
          "Monuments Historiques : déduction sans plafond, adapté aux hauts revenus",
          "Nue-propriété : décote de 30 à 40% sur le prix d'achat, idéale pour préparer la retraite"
        ]
      },
      {
        title: "L'alternative SCPI : la pierre papier",
        body: "Pour ceux qui souhaitent investir dans l'immobilier sans gérer un bien physique, les SCPI (Sociétés Civiles de Placement Immobilier) offrent une solution clé en main. Vous achetez des parts d'un parc immobilier mutualisé et percevez des loyers mensuels ou trimestriels, sans contrainte de gestion.",
        bullets: [
          "Accessible dès 1 000 € de versement",
          "Rendements moyens : 4 à 6% net de frais de gestion",
          "Mutualisation sur des centaines de biens (bureaux, commerces, santé, logistique)",
          "SCPI européennes : fiscalité allégée (pas de prélèvements sociaux)",
          "SCPI fiscales (Pinel, Malraux, déficit foncier) pour défiscaliser sans gérer"
        ]
      },
      {
        title: "Mon accompagnement immobilier locatif à Annecy",
        body: "Investir dans l'immobilier ne s'improvise pas : choix de la ville, du quartier, du bien, du dispositif, du financement, de l'assurance de prêt... Je vous accompagne à chaque étape pour sécuriser votre investissement et maximiser sa rentabilité.",
        bullets: [
          "Analyse de votre capacité d'investissement (revenus, fiscalité, endettement)",
          "Sélection des programmes immobiliers de qualité (partenaires triés sur le volet)",
          "Comparaison des dispositifs fiscaux selon votre situation",
          "Négociation du financement et de l'assurance de prêt",
          "Suivi de la mise en location et de la gestion locative"
        ]
      }
    ]}
    faq={[
      { q: "Combien faut-il pour investir en immobilier locatif à Annecy ?",
        a: "Tout dépend de votre capacité d'emprunt. Avec un apport de 10 à 20% du prix du bien et un revenu stable, un investissement Pinel à Annecy commence généralement autour de 180 000 € pour un T2. Le LMNP est accessible dès 100 000 € en résidence services." },
      { q: "Quelle différence entre Pinel et LMNP ?",
        a: "Le Pinel offre une réduction d'impôt immédiate (jusqu'à 14% sur 12 ans) mais impose des plafonds de loyers et de ressources des locataires. Le LMNP ne donne pas de réduction d'impôt directe mais permet d'amortir le bien comptablement, ce qui efface fiscalement les revenus locatifs pendant 15 à 20 ans." },
      { q: "Les SCPI sont-elles risquées ?",
        a: "Les SCPI comportent un risque de perte en capital (l'immobilier peut baisser) et un risque de liquidité (la revente prend quelques semaines à mois). Cependant, la mutualisation sur des centaines de biens limite considérablement le risque comparé à un investissement direct." },
      { q: "Faut-il privilégier l'ancien ou le neuf à Annecy ?",
        a: "Le neuf offre des frais de notaire réduits (2-3%) et bénéficie du Pinel. L'ancien offre du Denormandie (avec travaux), souvent plus rentable et permet d'investir en hyper-centre. Le choix dépend de votre objectif principal : défiscalisation maximale ou rendement locatif." }
    ]}
  />
);

export default PageInvestissementImmobilierAnnecy;
